import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-work-flow',
  templateUrl: './work-flow.component.html',
  styleUrls: ['./work-flow.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkFlowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/components/screens/contact/customer-detail/work-flow/work-flow.component.ts